export default __webpack_public_path__ + "static/media/application-strategy.02e3ef32.svg";